/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { forwardRef } from "react";

// react-router-dom components
import { Link as RouterLink } from "react-router-dom";

// Custom styles for MDLink
import MDLinkRoot from "components/MDLink/MDLinkRoot";

const MDLink = forwardRef(({ children, to, ...rest }, ref) => {
  return (
    <MDLinkRoot as={RouterLink} to={to} ref={ref} {...rest}>
      {children}
    </MDLinkRoot>
  );
});

MDLink.displayName = "MDLink";

export default MDLink;

